module.exports = __webpack_public_path__ + "img/ITW_hoehe_Belgien.831070ae.svg";